import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';
import { SET_LOADING, SET_PROCESSES, SET_PROCESS, ADD_NODE, ADD_LINK, DELETE_LINK } from './mutations';

import { processes as processesApi } from '@/api';

const buildActionObject = (action) => StoreModuleService.buildActionObject(MODULE_NAME, action);

export const loadProcesses = buildActionObject('loadProcesses');
export const createProcess = buildActionObject('createProcess');
export const createNode = buildActionObject('createNode');
export const createLink = buildActionObject('createLink');
export const deleteLink = buildActionObject('deleteLink');

// set_<stuff> actions here only commit mutations, they don't fetch from server
export const setProcess = buildActionObject('setProcess');

const actions = {
	...StoreModuleService.createDefaultActions(),
	async [loadProcesses.action]({ commit }) {
		commit(SET_LOADING, true);
		try {
			const processList = await processesApi.list();
			commit(SET_PROCESSES, Object.fromEntries(processList.map((p) => [p.id, p])));
		} finally {
			commit(SET_LOADING, false);
		}
	},
	async [createProcess.action]({ commit }, payload) {
		const resp = await processesApi.create(payload);
		commit(SET_PROCESS, resp);
		return resp;
	},
	async [setProcess.action]({ commit }, process) {
		commit(SET_PROCESS, process);
	},
	async [createNode.action]({ commit }, { processId, workflow }) {
		const node = await processesApi.nodes.create({ workflow, process: processId });
		commit(ADD_NODE, { processId, node });
		return node;
	},
	async [createLink.action]({ commit }, { processId, source, target, type }) {
		const link = await processesApi.links.create({ source, target, type });
		commit(ADD_LINK, { processId, link });
		return link;
	},

	async [deleteLink.action]({ commit }, { processId, linkId }) {
		await processesApi.links.delete(linkId);
		commit(DELETE_LINK, { processId, linkId });
	},
};

export default actions;
